import React, { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { postForm } from "../../../lib/forms";
import { track } from "../../../lib/analytics";

const field = "mt-1 w-full rounded-lg border border-brand-line bg-white px-3 py-2.5 text-sm text-brand-ink outline-none focus:border-brand-ink";

export const ProviderInterestForm = () => {
  const [form, setForm] = useState({ name: "", email: "", company: "", website: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");
    try {
      await postForm("provider-interest", form);
      track("provider_interest_submitted", {});
      setStatus("done");
    } catch (err) {
      setStatus("error");
      setError(err.message);
    }
  };

  if (status === "done") {
    return (
      <div data-testid="provider-success" className="rounded-2xl border border-brand-line bg-white p-7">
        <div className="inline-flex items-center gap-2 text-brand-ink"><Check size={18} className="text-brand-terracotta" /> <span className="font-display text-xl">Thanks for your interest</span></div>
        <p className="mt-2 text-sm text-brand-inkSoft">We&apos;ll be in touch about featuring your retreat on YogaToYacht.</p>
      </div>
    );
  }

  return (
    <form data-testid="provider-form" onSubmit={submit} className="rounded-2xl border border-brand-line bg-white p-7">
      <p className="overline text-brand-inkSoft">For retreat providers</p>
      <h3 className="mt-2 font-display text-2xl text-brand-ink">List your retreat</h3>
      <p className="mt-1 text-sm text-brand-inkSoft">Run retreats or sailing trips? Register your interest in being featured.</p>
      <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="block"><span className="text-xs text-brand-inkSoft">Your name</span><input data-testid="prov-name" required value={form.name} onChange={set("name")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Email</span><input data-testid="prov-email" type="email" required value={form.email} onChange={set("email")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Company / retreat name</span><input data-testid="prov-company" required value={form.company} onChange={set("company")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Website (optional)</span><input data-testid="prov-website" value={form.website} onChange={set("website")} className={field} /></label>
      </div>
      <label className="mt-3 block"><span className="text-xs text-brand-inkSoft">Tell us about your retreat (optional)</span><textarea data-testid="prov-message" rows={3} value={form.message} onChange={set("message")} className={field} /></label>
      {status === "error" && <p data-testid="prov-error" className="mt-3 text-sm text-red-600">{error}</p>}
      <button data-testid="prov-submit" type="submit" disabled={status === "loading"} className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-inkSoft disabled:opacity-60">
        {status === "loading" ? "Sending…" : "Register interest"} <ArrowRight size={15} />
      </button>
    </form>
  );
};

export default ProviderInterestForm;
